import { Box } from '@mui/material';
import type { Invoice } from '../models/types';

export default function InvoiceViewerDialog({
  invoicePdfUrl,
}: {
  invoicePdfUrl: string;
}) {
  return (
    <Box height="70vh">
      <iframe
        // PDF query parameter options
        // https://pdfobject.com/pdf/pdf_open_parameters_acro8.pdf
        src={`${invoicePdfUrl}#toolbar=1&navpanes=0&view=FitW`}
        width="100%"
        height="100%"
        style={{ border: 'none' }}
        title="PDF Viewer"
      />
    </Box>
  );
}
